<script setup>
import PriceFormatter from '@/components/PriceFormatter.vue'
import { defineProps } from 'vue';
import {useOrderDataStore} from "@/stores/orderDataStore";
import {UseMoneyStore} from "@/stores/moneyStore";
import {useI18n} from "vue-i18n";

const orderDataStore = useOrderDataStore();
const moneyStore = UseMoneyStore();
const {t} = useI18n();

defineProps({
  refundMethod: {
    type: Object,
    required: true
  }
})

</script>

<template>
  <div class="mb-6">
    <label class="flex items-center">
      <input
          type="radio"
          name="how"
          id="viva"
          :value="refundMethod.key"
          v-model="moneyStore.selectedHowReturnMoney"
          class="accent-bw-black mr-2"
      />
      <span class="block">{{ t('returnToCard') }}</span>
    </label>

    <!-- Greece -->
    <span v-if="orderDataStore.shippingCountry === 'GR'" class="ml-5 text-bw-lightDarkGrey italic responsive-body-xsmall block">
      ({{ t('returnMoneyToCard') }},<br />
      {{ t('returnFee') }} <PriceFormatter :price="orderDataStore.serviceCost.toString()" /> {{ t('offsetOnRefund') }})
    </span>

    <!-- Cyprus -->
    <span v-else class="ml-5 text-bw-lightDarkGrey italic responsive-body-xsmall block">
      ({{ t('returnMoneyToCard') }})
    </span>
  </div>
</template>
